import { Button, ButtonProps } from '@talentmesh/ui/components/button';
import { Tooltip, TooltipContent, TooltipTrigger } from '@talentmesh/ui/components/tooltip';
import { X } from 'lucide-react';
import UIStrings from '@/Utils/UIStrings';

const ClearFiltersButton = (props: ButtonProps) => {
    return (
        <Tooltip>
            <TooltipTrigger asChild>
                <Button
                    size="icon-xs"
                    variant="ghost"
                    className="text-muted-foreground"
                    aria-label={UIStrings.ClearFilters}
                    {...props}
                >
                    <X />
                </Button>
            </TooltipTrigger>
            <TooltipContent>{UIStrings.ClearFilters}</TooltipContent>
        </Tooltip>
    );
};

export default ClearFiltersButton;
